export const supportedCountries = ['AT', 'CH', 'DE', 'DK', 'ES', 'FI', 'GB', 'NL', 'NO', 'NZ', 'SE'];
export const supportedCountriesRequiringStates = ['AU'];
